import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Session is an httpOnly cookie set by the backend; nothing is stored client-side.
axios.defaults.withCredentials = true;
const authHeaders = () => ({});

export const api = {
  register: async (payload) => {
    const { data } = await axios.post(`${API}/auth/register`, payload);
    return data.user;
  },
  login: async (payload) => {
    const { data } = await axios.post(`${API}/auth/login`, payload);
    return data.user;
  },
  me: async () => {
    const { data } = await axios.get(`${API}/auth/me`);
    return data.user;
  },
  logout: async () => {
    await axios.post(`${API}/auth/logout`);
  },

  listAlerts: async () => {
    const { data } = await axios.get(`${API}/alerts`, { headers: authHeaders() });
    return data;
  },
  createAlert: async (payload) => {
    const { data } = await axios.post(`${API}/alerts`, payload, { headers: authHeaders() });
    return data;
  },
  deleteAlert: async (id) => {
    await axios.delete(`${API}/alerts/${id}`, { headers: authHeaders() });
  },

  chat: async (session_id, message) => {
    const { data } = await axios.post(`${API}/chat`, { session_id, message });
    return data.reply;
  },

  listWishlist: async () => {
    const { data } = await axios.get(`${API}/wishlist`, { headers: authHeaders() });
    return data;
  },
  addWishlist: async (deal) => {
    const { data } = await axios.post(`${API}/wishlist`, { deal }, { headers: authHeaders() });
    return data;
  },
  removeWishlist: async (dealId) => {
    await axios.delete(`${API}/wishlist/${dealId}`, { headers: authHeaders() });
  },
  setWishlistTarget: async (dealId, targetPoints) => {
    const { data } = await axios.put(`${API}/wishlist/${dealId}/target`, { targetPoints }, { headers: authHeaders() });
    return data;
  },

  listNotifications: async () => {
    const { data } = await axios.get(`${API}/notifications`, { headers: authHeaders() });
    return data;
  },
  checkNotifications: async () => {
    const { data } = await axios.post(`${API}/notifications/check`, {}, { headers: authHeaders() });
    return data;
  },
  markNotificationsRead: async () => {
    await axios.post(`${API}/notifications/read-all`, {}, { headers: authHeaders() });
  },

  trackBookClick: (deal, target, source = "card") => {
    const body = { dealId: String(deal.id), origin: deal.origin.code, destination: deal.destination.code, date: deal.date, airlineCode: deal.airlineCode, program: deal.program, cabin: deal.cabin, points: deal.points, target, source };
    return axios.post(`${API}/events/book-click`, body).catch(() => {});
  },
  trending: async (days = 7) => (await axios.get(`${API}/trending`, { params: { days } })).data,
  getWallet: async () => (await axios.get(`${API}/wallet`)).data,
  saveWallet: async (balances) => (await axios.put(`${API}/wallet`, { balances })).data,

  trackFlight: async (q) => (await axios.get(`${API}/tracker/flight/${encodeURIComponent(q)}`)).data,
  trackAirport: async (code, airline) => (await axios.get(`${API}/tracker/airport/${code}`, { params: airline ? { airline } : {} })).data,
  trackerSchedule: async (flight) => (await axios.get(`${API}/tracker/schedule/${encodeURIComponent(flight)}`)).data,

  digestPreview: async () => {
    const { data } = await axios.get(`${API}/admin/digest/preview`, { responseType: "text" });
    return data;
  },
  digestSendNow: async () => {
    const { data } = await axios.post(`${API}/admin/digest/send`);
    return data;
  },
  adminInsights: async (days = 30) => {
    const { data } = await axios.get(`${API}/admin/insights`, { params: { days } });
    return data;
  },

  shareDeal: async (deal) => {
    const { data } = await axios.post(`${API}/deals/share`, { deal });
    return data.id;
  },
  getDeal: async (id) => {
    const { data } = await axios.get(`${API}/deals/${id}`);
    return data;
  },

  newsletter: async (email) => {
    const { data } = await axios.post(`${API}/newsletter`, { email });
    return data;
  },

  createCheckout: async (payload) => {
    const { data } = await axios.post(`${API}/payments/checkout`, payload);
    return data;
  },
  paymentStatus: async (sessionId) => {
    const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
    return data;
  },
};
